<title>{{ ndcCreditVoucherRedemptionPage.htmlTitle }}</title>
<app-banner [banner]="ndcCreditVoucherRedemptionPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div id="confpn-voucher" class="conf" *ngIf="issueRedeemSuccess">
  <div id="confDet" class="conf">
    <i class="fa fa-check-circle"></i>
    {{ ndcCreditVoucherRedemptionLabels.redeemSuccess }}
  </div>
</div>
<div id="errorpn-VoucherRedeem" *ngIf="redeemFailedMsg">
  <div id="errDet" class="err-VoucherRedeem">
    {{ redeemFailedMsg }}
  </div>
</div>
<div class="container-fluid minHeightVocherRedeem commonFormsCss" *ngIf="!issueRedeemSuccess">
  <div id="VoucherRedemption">
    <div class="bannertron banner-frm-pb">
      <div class="container">
        <div></div>
      </div>
    </div>
    <form [formGroup]="redeemCreditVoucherForm">
      <div id="redemption" class="container brddott mb-50 commonFormsCss">
        <div id="preq">
          <div id="errpn" class="err mb-10" *ngIf="requiredFieldError">
            {{ ndcCreditVoucherRedemptionLabels.checkAllRequired }}
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-7 float-left" [hidden]="showRedemptionForm || showCustomerSupportMessage">
              <div class="row">
                <div class="col-sm-11 mb-10">
                  <div>
                    <h3>{{ ndcCreditVoucherRedemptionLabels.mainHeading }}</h3>
                    <span class="lbcontainer">
                      {{ ndcCreditVoucherRedemptionLabels.instructionText }}

                      <br />
                      <br />
                    </span>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-10">
                  <div>
                    <label class="lbcontainer"> {{ ndcCreditVoucherRedemptionLabels.outboundTravelWithin72Hours }} </label>
                  </div>
                </div>

                <div class="col-sm-2 toggle-button">
                  <div class="toggleBtnCss">
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="getChangedValue1($event)"
                      formControlName="travelWithiHhours"
                    >
                    </ng-toggle>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-10">
                  <label class="lbcontainer">{{ ndcCreditVoucherRedemptionLabels.bookingRequireInstantTicketing }} </label>
                </div>
                <div class="col-sm-2">
                  <div class="toggleBtnCss">
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="getChangedValue1($event)"
                      formControlName="requireInstantTicketing"
                    >
                    </ng-toggle>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-10">
                  <label class="lbcontainer">{{ ndcCreditVoucherRedemptionLabels.isADCrequired }} </label>
                </div>
                <div class="col-sm-2">
                  <div class="toggleBtnCss">
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="getChangedValue1($event)"
                      formControlName="adcRequired"
                    >
                    </ng-toggle>
                  </div>
                </div>
              </div>

              <div id="rwcc" class="row mb-3" [hidden]="f['adcRequired'].value === false">
                <div class="col-sm-10">
                  <div>
                    <label class="lbcontainer">{{ ndcCreditVoucherRedemptionLabels.ADCcollectedViaCC }} </label>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="toggleBtnCss">
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="getChangedValue1($event)"
                      formControlName="adcCollectedCreditCard"
                    >
                    </ng-toggle>
                  </div>
                </div>
              </div>

              <div id="rwcc" class="row mb-3">
                <div class="col-sm-10">
                  <div>
                    <label class="lbcontainer"> {{ ndcCreditVoucherRedemptionLabels.voucherOriginateFrom }} </label>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="toggleBtnCss">
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="getChangedValue1($event)"
                      formControlName="BAdirectCustomer"
                    >
                    </ng-toggle>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-7">
                  <span class="sml"> {{ ndcCreditVoucherRedemptionLabels.YourLocationCountry }} </span><br />
                  <select
                    #countryCode
                    name="countrycode"
                    class="form-control"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="selectedCountry.name"
                    (ngModelChange)="onChangeCountry($event)"
                    [ngClass]="{ 'is-invalid': requiredFieldError }"
                  >
                    <option *ngFor="let country of countries" [value]="country.name">
                      {{ country.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mb-5 mt-3">
                <div class="col-sm-9"></div>
                <div class="col-sm-2">
                  <button (click)="showNxt()" type="button" class="btn btn-lg btnblu"><i class="fa fa-angle-double-right"></i> {{ ndcCreditVoucherRedemptionLabels.next }}</button>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-7 float-left" *ngIf="showRedemptionForm">
              <h3>{{ ndcCreditVoucherRedemptionLabels.mainHeading }}</h3>

              <br />
              <h4>{{ ndcCreditVoucherRedemptionLabels.yourDetailsHeading }}</h4>
              <div class="row">
                <div class="col-sm-8 ms-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.contactName }}<span class="red">*</span></span
                    ><br />
                    <input
                      type="text"
                      formControlName="contactName"
                      maxlength="30"
                      placeholder="Contact Name "
                      class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f['contactName'].errors }"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['contactName'].errors">
                      {{ ndcCreditVoucherRedemptionLabels.invalidContactName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-8 ms-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.contactEmail }} <span class="red">*</span></span
                    ><br />
                    <input type="text" formControlName="contactEmail" maxlength="30" placeholder="eMail " class="form-control" [ngClass]="{ 'is-invalid': submitted && f['contactEmail'].errors }" />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['contactEmail'].errors">{{ ndcCreditVoucherRedemptionLabels.invalidEmail }}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-8 ms-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.contactPhone }} <span class="red">*</span></span
                    ><br />

                    <ngx-intl-tel-input
                      [cssClass]="'custom form-control'"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.UnitedKingdom"
                      [maxLength]="15"
                      [phoneValidation]="true"
                      [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.National"
                      name="phone"
                      formControlName="phone"
                    >
                    </ngx-intl-tel-input>
                    <!-- <intl-tel-input formControlName="phone" [name]="'my-name'" [cssClass]="'form-control'" [labelCssClass]="'col-sm-2 col-form-label'" [required]="true" [onlyLocalized]="false">
                    </intl-tel-input> -->
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['phone'].errors">{{ ndcCreditVoucherRedemptionLabels.invalidPhoneNumber }}</div>
                  </div>
                </div>
              </div>
              <div class="row"></div>

              <br />
              <h4>{{ ndcCreditVoucherRedemptionLabels.agencyDeatailsHeading }}</h4>
              <div class="row">
                <div class="col-sm-8 ms-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.agencyName }}<span class="red">*</span></span
                    ><br />
                    <input type="text" formControlName="agencyName" maxlength="100" placeholder="Agency Name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['agencyName'].errors }" />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['agencyName'].errors">
                      {{ ndcCreditVoucherRedemptionLabels.invalidAgencyName }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-8 ms-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.iata }} <span class="red">*</span></span
                    ><br />
                    <input
                      type="text"
                      formControlName="IATAnumber"
                      placeholder="IATA Number"
                      class="form-control"
                      maxlength="10"
                      [ngClass]="{ 'is-invalid': submitted && f['IATAnumber'].errors }"
                      (keypress)="keyPressNumbers($event)"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['IATAnumber'].errors">
                      {{ ndcCreditVoucherRedemptionLabels.invalidIATAnumber }}
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <h4>{{ ndcCreditVoucherRedemptionLabels.CreditVoucherDetailsHeading }}</h4>
              <div class="row">
                <div id="tgemdpn" class="col-sm-10 ms-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.creditVoucherRef }}<span class="red">*</span></span
                    ><br />
                    <div class="input-group mb-3">
                      <input id="tktp1" name="tktp1" type="text" class="vchrp1" formControlName="creditVoucherRefPrefix" value="125-" readonly="" />
                      <input
                        type="text"
                        formControlName="creditVoucherRef"
                        placeholder="Voucher Ref"
                        class="form-control vchr"
                        maxlength="10"
                        (keypress)="keyPressNumbers($event)"
                        (click)="clearErrorMsg()"
                        [ngClass]="{ 'is-invalid': (ticketsAdded && f['creditVoucherRef'].errors) || (submitted && ticketAndEMDList.length === 0) }"
                      />
                      <ng-toggle
                        onColor="{{ model1.onColor }}"
                        onText="{{ model1.onText }}"
                        offColor="{{ model1.offColor }}"
                        offText="{{ model1.offText }}"
                        [size]="model1.size"
                        (valueChange)="getChangedValue1($event)"
                        class="hide"
                      >
                      </ng-toggle>
                      <div class="toggleBtnCss toggle-large">
                        <ng-toggle
                          onColor="{{ model2.onColor }}"
                          onText="{{ model2.onText }}"
                          offColor="{{ model2.offColor }}"
                          offText="{{ model2.offText }}"
                          formControlName="TKTorEMDnumber"
                          [size]="model2.size"
                          (valueChange)="getChangedValue1($event)"
                        >
                        </ng-toggle>
                      </div>
                      <div class="input-group-btn"></div>

                      <div class="input-group-btn">
                        <!-- <input type="checkbox" checked data-bs-toggle="toggle" data-on="EMD" data-off="ETKT" data-onstyle="success" data-size="sm" />
                           -->

                        <button class="btn btnblu" type="button" (click)="addTicket()">{{ ndcCreditVoucherRedemptionLabels.add }}</button>
                      </div>
                    </div>

                    <div class="field-validation-valid text-danger" *ngIf="(ticketsAdded && f['creditVoucherRef'].errors) || (ticketsAdded && !f['creditVoucherRef'].value)">
                      {{ ndcCreditVoucherRedemptionLabels.invalidTicketNtmber }}
                    </div>
                    <div class="field-validation-valid text-danger" *ngIf="showDuplicateVoucherError">{{ ndcCreditVoucherRedemptionLabels.voucherAlreadyEntered }}</div>
                  </div>
                  <input type="hidden" id="tkts" name="tkts" value="" />
                  <div class="mt-10">
                    <h5>{{ ndcCreditVoucherRedemptionLabels.ticketNumbers }}</h5>
                    <div id="pntks" class="panel">
                      <ul class="no-bullets">
                        <li *ngFor="let ticket of ticketAndEMDList">
                          <a (click)="deltkt(ticket.number)"><i class="fa fa-trash"></i></a>{{ ticket.type }}
                          {{ ticket.number }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-8 mb-4 ms-3 mt-3">
                  <div>
                    <span class="sml">{{ ndcCreditVoucherRedemptionLabels.newPNR }}<span class="red">*</span></span
                    ><br />
                    <input
                      id="nwPNR"
                      name="nwPNR"
                      maxlength="6"
                      type="text"
                      class="form-control"
                      placeholder="New PNR"
                      maxlength="6"
                      formControlName="PNRnumber"
                      (keypress)="keyPressSpace($event)"
                      [ngClass]="{ 'is-invalid': submitted && f['PNRnumber'].errors }"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['PNRnumber'].errors">
                      {{ ndcCreditVoucherRedemptionLabels.invalidPNR }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-20">
                <div class="col-sm-1 ms-3">
                  <div class="toggleBtnCss">
                    <!-- <input type="checkbox" checked data-bs-toggle="toggle" data-on="Yes" data-off="No" data-onstyle="success" data-size="sm" /> -->
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      formControlName="applyNameChange"
                      (valueChange)="onApplyNameChange($event)"
                    >
                    </ng-toggle>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div>
                    <label> {{ ndcCreditVoucherRedemptionLabels.applyingNameChange }} </label>
                  </div>
                </div>
              </div>

              <div id="pnbaci" class="row" *ngIf="f['applyNameChange'].value">
                <div class="col-sm-10 ms-3 mb-3">
                  <textarea
                    id="nwBaci"
                    name="nwBaci"
                    formControlName="nwBaci"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f['nwBaci'].errors }"
                    placeholder="enter the CLID, On Business or BACCI number which appears in the original ticket and must be included in the New PNR "
                  ></textarea>
                </div>
              </div>

              <div class="row mt-10">
                <div class="col-sm-1 ms-3">
                  <div class="toggleBtnCss">
                    <!-- <input type="checkbox" checked data-bs-toggle="toggle" data-on="No" data-off="Yes" data-onstyle="success" data-size="sm" /> -->
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="onUSCanadaFlightSelect($event)"
                    >
                    </ng-toggle>
                  </div>
                </div>
                <div class="col-sm-8">
                  <label> {{ ndcCreditVoucherRedemptionLabels.bookingContainCanadaUSflight }} </label>
                </div>
              </div>
              <div id="tgCpn" class="row mt-10" *ngIf="showSFPD">
                <div class="col-sm-1 ms-3">
                  <div class="toggleBtnCss">
                    <!-- <input type="checkbox" checked data-bs-toggle="toggle" data-on="No" data-off="Yes" data-onstyle="success" data-size="sm" /> -->
                    <ng-toggle
                      onColor="{{ model1.onColor }}"
                      onText="{{ model1.onText }}"
                      offColor="{{ model1.offColor }}"
                      offText="{{ model1.offText }}"
                      [size]="model1.size"
                      (valueChange)="getChangedValue1($event)"
                      formControlName="passengerSFPD"
                    >
                    </ng-toggle>
                  </div>
                </div>
                <div class="col-sm-8">
                  <label> {{ ndcCreditVoucherRedemptionLabels.enteredSFPD }} </label>
                </div>
                <div class="field-validation-valid text-danger ms-5" *ngIf="submitted && showSFPD && f['passengerSFPD']?.value === false">
                  {{ ndcCreditVoucherRedemptionLabels.invalidSFPD }}
                </div>
              </div>
              <div class="row"></div>

              <div class="row mt-5 pt-20">
                <div class="col-sm-10">
                  <label id="lbchk1" [ngClass]="{ 'is-invalid': submitted && f['confirmAdditionalCollection'].value === false }">
                    <input id="chk1" name="chk1" type="checkbox" formControlName="confirmAdditionalCollection" />
                    {{ ndcCreditVoucherRedemptionLabels.additionalCollectionRequired }}
                    <span class="red">*</span>
                  </label>
                </div>
              </div>

              <div class="row pt-20">
                <div class="col-sm-10">
                  <label id="lbchk2" [ngClass]="{ 'is-invalid': submitted && f['confirmEMD'].value === false }">
                    <input id="chk2" name="chk2" type="checkbox" formControlName="confirmEMD" />
                    {{ ndcCreditVoucherRedemptionLabels.confirmResidualValue }} <span class="red">*</span>
                  </label>
                </div>
              </div>

              <div class="row mt-5 mb-5 pt-30">
                <div class="col">
                  <button (click)="goBack()" type="button" class="btn btn-lg btnblu mb-3"><i class="fa fa-angle-double-left"></i> {{ ndcCreditVoucherRedemptionLabels.back }}</button>
                </div>
                <div class=""></div>
                <div class="col">
                  <button (click)="submitVoucherRedemption(redeemCreditVoucherForm)" type="button" class="btn btn-lg btnblu">
                    <i class="fa fa-edit"></i> {{ ndcCreditVoucherRedemptionLabels.Submit }}
                  </button>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-7 mt-30" *ngIf="showCustomerSupportMessage">
              <div class="row">
                <app-section [sections]="ndcCreditVoucherRedemptionPage.NDCCallSupportSections"></app-section>
              </div>
            </div>

            <div class="col-sm-12 col-md-5 bggry float-right pt-3">
              <app-section [sections]="ndcCreditVoucherRedemptionPage.TermsAndConditionsSections"></app-section>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
